export default __webpack_public_path__ + "static/media/calendario_repasse_2025.85edcf7a.webp";